import { useCallback, useContext } from 'react';
import apiRoutes from '../../../config/api/routes';
import { LogActionTypes } from './constants';
import { LogEntry, LogEntryAdditionalData } from './types';
import { DataLoggingContext } from './DataLoggingContext';
import { getUserRole, useUser } from '../hooks';
import { format } from 'date-fns';
import { store } from '../store';

const BACKEND_DATE_FORMAT = "yyyy-MM-dd'T'HH:mm:ss";

export const useDataLogging = () => {
  const { user, isStudent, isTeacher } = useUser();
  const { jwt } = store.getState().auth;
  const { sessionId } = useContext(DataLoggingContext);

  return useCallback(
    (action: LogActionTypes, additionalData?: LogEntryAdditionalData) => {
      if (sessionId !== '' && user != null && (isStudent || isTeacher)) {
        const body: LogEntry = {
          sessionId,
          timestamp: format(new Date(), BACKEND_DATE_FORMAT),
          userId: user.id || '',
          userRole: getUserRole(user),
          action,
          url: window.location.href,
          additionalData: additionalData,
          userAgent: window.navigator.userAgent ?? '',
        };

        // SEND NEW LOG_ENTRY TO API
        fetch(apiRoutes.dataLogging(), {
          method: 'POST',
          body: JSON.stringify(body),
          headers: {
            Authorization: `Bearer ${jwt}`,
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
        }).then();
      }
    },
    [sessionId, user, isStudent, isTeacher, jwt]
  );
};
